import request from '@/utils/request'
export const queryPage = '/icps/system/sign/basics/point/query_page'
// export const saveOrUpdate = '/icps/system/sign/basics/point/save_or_update'
export function save_or_update(data) {
  return request({
    url: '/icps/system/sign/basics/point/save_or_update',
    method: 'post',
    data
  })
}
export function itemList(params) {
  return request({
    url: '/icps/system/sign/basics/point/item_list',
    method: 'get',
    params
  })
}
export function query_pagedeletes(data) {
  return request({
    url: '/icps/system/sign/basics/point/deletes',
    method: 'POST',
    data
  })
}